import React from "react"
import ProductPresenterGeneral from "./tabs/ProductPresenterGeneral"
import ProductPresenterRoomTypes from './tabs/ProductPresenterRoomTypes'
import ProductPresenterTaxesAndFees from "./tabs/ProductPresenterTaxesAndFees"
import ProductPresenterImages from "./tabs/ProductPresenterImages"
import ProductPresenterHistory from "./tabs/ProductPresenterHistory"

class ProductPresenterWorkspace extends React.Component {

  constructor(props) {
    super(props);
  };

  render() {
    if(this.props.activeTab === 'general'){
      return(
        <div>
          <ProductPresenterGeneral {...this.props} />
        </div>
      );
    } else if(this.props.activeTab === 'room_types') {
      return(
        <div>
          <ProductPresenterRoomTypes {...this.props} />
        </div>
      );
    } else if(this.props.activeTab === 'taxes'){
      return(
        <div>
          <ProductPresenterTaxesAndFees {...this.props} />
        </div>
      );
    } else if (this.props.activeTab === 'images'){
      return(
        <div>
          <ProductPresenterImages {...this.props} />
        </div>
      );
    } else if (this.props.activeTab === 'history'){
      return(
        <div>
          <ProductPresenterHistory {...this.props} />
        </div>
      );
    };
  };

}

export default ProductPresenterWorkspace
